import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 5v14l8 -7l-8 -7","key":"svg-0"}],["path",{"d":"M14 5v14l8 -7l-8 -7","key":"svg-1"}]]

/**
 * IconPlayerTrackNext
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItcGxheWVyLXRyYWNrLW5leHQiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTMgNXYxNGw4IC03bC04IC03IiAvPgogIDxwYXRoIGQ9Ik0xNCA1djE0bDggLTdsLTggLTciIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/player-track-next
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconPlayerTrackNext = createReactComponent('outline', 'player-track-next', 'PlayerTrackNext', __iconNode);

export default IconPlayerTrackNext;